if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          if (window.FoxTheme && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish(
              FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
              {
                data: {
                  event,
                  target,
                  selectedOptionValues: this.selectedOptionValues,
                },
              }
            );
          }

          this.reloadWithCorrectVariant();
        });
      }

      reloadWithCorrectVariant() {
        let tries = 0;

        const interval = setInterval(() => {
          tries++;

          const variantInput =
            document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
            document.querySelector('input[name="id"]');

          const variantId = variantInput?.value;

          if (variantId && !isNaN(Number(variantId))) {
            clearInterval(interval);

            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);

            window.location.href = url.toString();
          }

          if (tries >= 20) {
            clearInterval(interval);
          }
        }, 400);
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const oldSelected = Array.from(target.options).find((option) =>
            option.hasAttribute('selected')
          );

          if (oldSelected) {
            oldSelected.removeAttribute('selected');
          }

          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;

          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value] > .swatch');

          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              'unset'
            );
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value]');

          if (selectedSwatchValue) {
            selectedSwatchValue.innerHTML = value;
          }
        }
      }
    }
  );
}

/* Studioline Bildwechsel */
(function () {
  let lastUrl = null;

  function getSelectedValue() {
    return document
      .querySelector('.tcustomizer__dropdown-button span')
      ?.textContent
      ?.trim();
  }

  function getSku() {
    return document
      .querySelector('.product__sku')
      ?.textContent
      ?.replace('Artikelnummer:', '')
      ?.trim();
  }

  function getImage() {
    return (
      document.querySelector('img[id^="SelectedVariantImage"]') ||
      document.querySelector('.product__media-list img')
    );
  }

  function updateStudiolineImage() {
    const selectedValue = getSelectedValue();
    const sku = getSku();
    const image = getImage();

    if (!image || !sku || selectedValue !== 'Studioline') return;

    const newUrl = `https://www.mtl-privatelabel.de/cdn/shop/files/Studioline_${sku}.png`;

    if (image.src.includes(`Studioline_${sku}.png`)) return;

    lastUrl = newUrl;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', newUrl);
    image.style.objectFit = 'contain';
  }

  function forceUpdateLoop() {
    updateStudiolineImage();

    let count = 0;
    const interval = setInterval(() => {
      count++;
      updateStudiolineImage();

      if (count >= 20) {
        clearInterval(interval);
      }
    }, 100);
  }

  function initObserver() {
    const productMedia =
      document.querySelector('.product__media-list') ||
      document.querySelector('.product__media-gallery') ||
      document.body;

    const observer = new MutationObserver(() => {
      updateStudiolineImage();
    });

    observer.observe(productMedia, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes']
    });

    forceUpdateLoop();
  }

  document.addEventListener('DOMContentLoaded', initObserver);
  document.addEventListener('click', forceUpdateLoop);
  document.addEventListener('change', forceUpdateLoop);
})();